module.exports = __webpack_public_path__ + "assets/55908c1e173a092383e4747cfaa2230c.jpg";